import { useRouter as useNpRouter } from "@bprogress/next";
import { useNavUrl } from "./useNavUrl";
import { URL } from "$constants/navigation";

export const useRouter = () => {
  const handleUrl = useNavUrl();
  const { push, replace, prefetch, ...other } = useNpRouter();

  return {
    ...other,
    push: (url: URL) => push(handleUrl(url)),
    replace: (url: URL, ...other: any) => replace(handleUrl(url), ...other),
    prefetch: (url: URL, ...other: any) => prefetch(handleUrl(url), ...other),
  };
};
